export const UC_PATHS = {
  broadcasts: "/broadcasts",
  createTelegram: "/broadcasts/create/telegram",
  createCommunity: "/broadcasts/create/community",
  createPush: "/broadcasts/create/push",
  templatesTab: "/broadcasts?tab=templates",
  templateCreate: "/broadcasts/templates/create",
  templateEdit: "/broadcasts/templates/edit",
  rationalePdfDesign: "/broadcasts/rationale-pdf",
  emailCompose: "/ComposeEmail",
  whatsappCreate: "/whatsapp-broadcasts/select",
  whatsappTemplates: "/whatsapp-templates/Approved",
  whatsappPresetTemplate: "/create-notification-template",
  whatsappCustomTemplate: "/WhatsappTemplate",
  mySubscriptions: "/#/my-subscriptions",
  telegramIntegration: "/#/Integrations/telegram",
};
